import { useState } from "react";
import { Button } from "@/components/ui/Button";
import { Modal } from "@/components/ui/Modal";

// „Wycofaj złożony wniosek" — nieodwracalne. Skutki zależą od kanału (papier: wpis DLC_02
// anulowany; e-Doręczenia: przesyłka DLC_09 „Wycofana") i od sprawy (automatyczna bez niczego
// poza pismem wniosku znika, inaczej pismo dostaje w niej status „Wycofany”, pakiet odpięty —
// sprawy nie rusza) — backend: withdrawal.case_effect. Wniosek kończy się jako „Anulowany”.
export function WithdrawSubmissionModal({
  number, channel, caseEffect, untracked, pending, error, onClose, onConfirm,
}: {
  number: string;
  channel: string | null;
  caseEffect: "delete" | "mark" | "none";
  /** System nie śledzi wysyłki (opis) — wymagamy świadomego potwierdzenia. */
  untracked: string | null;
  pending: boolean;
  error: string | null;
  onClose: () => void;
  onConfirm: () => void;
}) {
  const [confirmed, setConfirmed] = useState(false);
  return (
    <Modal open onClose={onClose} title={`Wycofaj złożony wniosek ${number}`} size="sm">
      <div className="space-y-3 text-sm">
        <div className="border border-red-300 bg-red-50 text-red-800 px-3 py-2">
          Wycofanie złożonego wniosku jest <b>nieodwracalne</b>.
          {untracked ? "" : " Pismo nie zostanie wysłane do urzędu."}
        </div>
        {untracked && (
          <div className="border border-amber-300 bg-amber-50 text-amber-900 px-3 py-2 space-y-2">
            <p>
              <b>{untracked}</b> — system nie wie, czy pismo nie wyszło już do urzędu. Wycofanie
              anuluje wniosek w systemie; jeśli pismo zostało wysłane, wycofaj je w urzędzie
              osobnym pismem.
            </p>
            <label className="flex items-start gap-2">
              <input type="checkbox" className="mt-0.5" checked={confirmed}
                     onChange={(e) => setConfirmed(e.target.checked)} />
              <span>Rozumiem — pismo nie zostało wysłane albo wycofam je w urzędzie sam(a).</span>
            </label>
          </div>
        )}
        <ul className="list-disc pl-5 space-y-1 text-[var(--color-text-secondary)]">
          {channel === "paper" && (
            <li>
              Pismo w dzienniku DLC_02 zostanie <b>anulowane</b> — dział obiegu go nie wyśle (wpis
              zostaje w dzienniku jako „Anulowane”).
            </li>
          )}
          {channel === "edoreczenia" && (
            <li>
              Przesyłka w kolejce e-Doręczeń dostanie status <b>„Wycofana”</b> — CEO jej już nie
              zaakceptuje ani nie wyśle.
            </li>
          )}
          {caseEffect === "delete" && (
            <li>Sprawa założona automatycznie przy wysyłce zostanie <b>usunięta</b> razem z pismem wniosku.</li>
          )}
          {caseEffect === "mark" && (
            <li>Sprawa zostaje, a pismo wniosku zostanie w niej oznaczone jako <b>„Wycofany”</b>.</li>
          )}
          {caseEffect === "none" && (
            <li>Wniosek nie ma pisma w żadnej sprawie (np. został odpięty) — sprawy w Korespondencji nie zmieniamy.</li>
          )}
          <li>
            Wniosek zostanie <b>zakończony jako „Anulowany”</b> — nie da się go już wysłać ani
            poprawić. Poprawkę składasz <b>nowym wnioskiem</b>.
          </li>
        </ul>
        {error && <p className="text-xs text-red-600">{error}</p>}
        <div className="flex justify-end gap-2 pt-1">
          <Button size="sm" variant="ghost" onClick={onClose} disabled={pending}>Anuluj</Button>
          <Button size="sm" variant="danger" loading={pending} disabled={!!untracked && !confirmed}
                  onClick={onConfirm}>
            Wycofaj wniosek
          </Button>
        </div>
      </div>
    </Modal>
  );
}
